module.exports = __webpack_public_path__ + "img/科佳.82c9bd74.jpg";